export const locationData = {
  'Western Cape': [
    'Cape Town – Southern Suburbs',
    'Cape Town – Northern Suburbs',
    'Cape Town – Atlantic Seaboard',
    'Cape Town – Southern Peninsula',
    'Cape Flats',
    'West Coast',
    'Boland; Stellenbosch',
    'Helderberg; Overberg',
    'Garden Route',
    'Klein Karoo',
    'Central Karoo'
  ],
  'Eastern Cape': [
    'Nelson Mandela Bay',
    'Buffalo City',
    'Sunshine Coast',
    'Wild Coast',
    'Amatola Region',
    'Sarah Baartman District',
    'Karoo Heartland',
    'Transkei'
  ],
  'Northern Cape': [
    'Kimberley & Diamond Field',
    'Kalahari',
    'Namaqualand',
    'Upper Karoo',
    'Green Kalahari',
    'Richtersveld'
  ],
  'Free State': [
    'Mangaung/Bloemfontein Area',
    'Lejweleputswa/Goldfields',
    'Eastern Free State',
    'Northern Free State',
    'Xhariep District'
  ],
  'KwaZulu-Natal': [
    'Durban/Ethekwini',
    'North Coast',
    'South Coast',
    'Pietermaritzburg/UMgungundlovu',
    'Midlands',
    'Drakensberg',
    'Zululand',
    'Umkhanyakude',
    'Harry Gwala Region'
  ],
  'Gauteng': [
    'Johannesburg North',
    'Johannesburg South',
    'West Rand',
    'East Rand (Ekurhuleni)',
    'Sandton Area',
    'Pretoria/Tshwane',
    'Vaal Triangle'
  ],
  'North West': [
    'Bojanala/Platinum Region (incl. Rustenburg area)',
    'Dr Kenneth Kaunda District',
    'Ngaka Modiri Molema District',
    'Dr Ruth Segomotsi Mompati District'
  ],
  'Mpumalanga': [
    'Highveld',
    'Lowveld',
    'Panorama Route',
    'Ehlanzeni Region',
    'Gert Sibande District',
    'Nkangala District'
  ],
  'Limpopo': [
    'Waterberg',
    'Capricorn District',
    'Vhembe',
    'Mopani',
    'Sekhukhune'
  ]
};

export const provinces = Object.keys(locationData);
